export interface ICommon {
  initialURL: string;
  loading: boolean;
  message: string | null;
  error: string | null;
}

class CommonClass implements ICommon {
  initialURL: string = '';
  loading: boolean = false;
  message: string | null = null;
  error: string | null = null;

  constructor(initialURL: string, loading: boolean, message: string | null, error: string | null) {
    this.initialURL = initialURL;
    this.loading = loading;
    this.message = message;
    this.error = error;
  }
}

export default CommonClass;
